import React, { useEffect, useState } from "react";
import logo from "../assets/img/bjp.png";
import InterfaceView from "../components/common/InterfaceView";
import { Alert } from "antd";
import { addLocation, getInterface } from "../api/userCard";
import { useParams } from "react-router-dom";
import axios from "axios";

function InterfaceViewPage() {
  const params = useParams();
  const [pre, setPre] = useState(true);
  const [interfaceData, setInterfaceData] = useState([]);


//   setTimeout(() => {
//     setPre(preview);
//   }, 2500);

  useEffect(() => {
    const getDetails = async () => {
      try {
        const { data } = await getInterface(params.id);
        if (data.success)
        setInterfaceData(data?.Interface);
        setPre(false);
        const liveLocation = await axios.get('https://ipapi.co/json')
        await addLocation(data?.Interface._id, liveLocation.data)
      } catch (error) {
        console.log(error);
        setPre(false);
      }
    };

    getDetails();
  }, [params.id]);

  return (
    <div>
      {pre ? (
        <div className="w-full h-screen flex items-center justify-center">
          <div className="flex flex-col">
            <img
              className="w-40"
              src={
                // partyLogo
                logo
              }
              alt=""
            />
            {/* {errorMessage ? (
              <Alert
                className="mt-5 bg-[#dffedc] text-green-900  w-52 "
                message={errorMessage}
                type="warning"
                closable
              />
            ) : (
              ""
            )} */}
          </div>
        </div>
      ) : (
        <InterfaceView interfaceData={interfaceData} />
      )}
    </div>
  );
}

export default InterfaceViewPage;
